"use strict";
import "polyfill";
import controllerF from 'controller/login';
import view from 'view/login';

const loginEl = document.getElementById('login');

controllerF(
    loginEl,
    loginEl.hasAttribute('data-production'),
    loginEl.dataset.siteName,
    view
).exec();
